import React, { useState } from 'react';
import { Card, Button, Form } from "tabler-react";
import postObject from '../../lib/postObject';

const MakeOfferModal = ({ recordId, closeMainModal }) => {
    const [reward, setReward] = useState(0)
    const [saveLoading, toggleSaveLoading] = useState(false)

    const makeOffer = () => {
        toggleSaveLoading(true)
        postObject('offers​/primeShipments', { primeShipmentId: recordId, reward: reward }).then(() => {
            toggleSaveLoading(false)
            closeMainModal()
        })
    }

    return (
        <Card>
            <Card.Header>
                <Card.Title>Make Offer</Card.Title>
                <Card.Options>
                    <Button
                        size="sm"
                        icon="x"
                        onClick={() => closeMainModal()}
                    />
                </Card.Options>
            </Card.Header>
            <Card.Body>
                <Form>
                    <Form.Input
                        label='reward'
                        value={reward}
                        onChange={e => setReward(e.target.value)}
                    />
                </Form>
            </Card.Body>
            <Card.Footer>
                <div style={{ textAlign: 'right' }}>
                    <Button
                        color="primary"
                        size="sm"
                        className={`ml-2 ${saveLoading ? 'btn-loading' : ''}`}
                        onClick={makeOffer}
                        disabled={saveLoading}
                    >
                        Apply
                    </Button>
                    <Button
                        color="secondary"
                        size="sm"
                        className="ml-2"
                        onClick={() => closeMainModal()}
                        disabled={saveLoading}
                    >
                        Cancel
                    </Button>
                </div>
            </Card.Footer>
        </Card>
    )
}

export default MakeOfferModal;